import FRApi from './_frApi';
import httpClient from '@/apis/base/httpclient';

class FrFormulaCustomAPI extends FRApi {
  constructor() {
    super();
  }
  controllerName = 'FrFormulaCustoms';

  /**
   * Add and Update multiple
   * nmtuan4 07.06.2022
   */
  addAndUpdateMultiple(param) {
    let request = {
      url: this.getAPIUrl() + '/AddAndUpdateMultiple',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu mặc định
   * nmtuan4 07.06.2022
   */
  defaultData(param) {
    let request = {
      url: this.getAPIUrl() + '/DefaultData',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new FrFormulaCustomAPI();
